import { memo, useEffect, useRef } from 'react'
import StyledComponentsRegistry from '@configs/registry'
import { DarkButton } from '@acko-tech/building-blocks.ui.button'
import Image from 'next/image'
import { OVERLAY_MODAL_DEFAULT_CROSS_ICON_SRC } from '@constants/crossIcon'
import { WrongModalState } from '@interfaces/fastag'
import styles from './wrongProviderModal.module.scss'
import {
  UNABLE_PROCESSING_SRC,
  UNABLE_TO_FETCH_BALANCE_DATA,
  WRONG_PROVIDER_SELECTION_DATA,
  defaultWrongModalState,
} from './constants'

interface WrongProviderModalProps {
  onClose: () => void
  setProviderErrorModal: Function
  setShowProvidersModal: Function
  providerErrorModal: WrongModalState
  isMobileDevice: boolean
}

const WrongProviderModal: React.FC<WrongProviderModalProps> = memo(
  ({ onClose, setProviderErrorModal, setShowProvidersModal, isMobileDevice, providerErrorModal }) => {
    useEffect(() => {
      if (isMobileDevice) setShowProvidersModal(true)
    }, [])
    const modalRef = useRef<HTMLDivElement>(null)
    const modalData = providerErrorModal.isServerError ? UNABLE_TO_FETCH_BALANCE_DATA : WRONG_PROVIDER_SELECTION_DATA

    return (
      <div>
        <div className={styles.overlay} onClick={onClose}>
          <div className={styles.modal} ref={modalRef}>
            <Image
              src={OVERLAY_MODAL_DEFAULT_CROSS_ICON_SRC}
              alt="Overlay cross Icon"
              width={24}
              height={24}
              onClick={onClose}
              className={styles.crossIcon}
            />
            <div className={styles.modalMainContainer}>
              {isMobileDevice && <div className={styles.line} />}
              <div className={styles.mainContent}>
                <Image
                  width={80}
                  height={80}
                  src={UNABLE_PROCESSING_SRC}
                  alt="Wrong provider icon"
                  className={styles.processErrorImage}
                />
                <div className={styles.texts}>
                  <div className={styles.heading}>{modalData?.heading}</div>
                  <div className={styles.subHeading}>{modalData?.subHeading}</div>
                </div>
              </div>
              <StyledComponentsRegistry>
                <DarkButton className={styles.ctaButton} onClick={() => setProviderErrorModal(defaultWrongModalState)}>
                  {modalData?.ctaText}
                </DarkButton>
              </StyledComponentsRegistry>
            </div>
          </div>
        </div>
      </div>
    )
  }
)

export default WrongProviderModal
